var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "b-button",
        {
          staticClass: "btn btn-primary",
          attrs: { size: _vm.size, title: "Fiche technique" },
          on: { click: _vm.show }
        },
        [_c("i", { staticClass: "fas fa-book-open" })]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: _vm.sizeModal,
            title: "Fiche technique",
            "hide-footer": "",
            "content-class": _vm.contentClass
          },
          model: {
            value: _vm.afficherModale,
            callback: function($$v) {
              _vm.afficherModale = $$v
            },
            expression: "afficherModale"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.https
              ? _c("div", { staticClass: "container-fluid" }, [
                  _c(
                    "object",
                    { attrs: { data: _vm.url, type: "application/pdf" } },
                    [
                      _c("div", [
                        _c("p", [
                          _vm._v(
                            "Un problème a été rencontré lors de l'ouverture de la fiche technique."
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            "Vous pouvez cliquer sur le lien suivant pour la télécharger :"
                          )
                        ]),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                              target: "_blank",
                              rel: "noopener noreferrer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.nouveauNavigateur(_vm.url)
                              },
                              contextmenu: function($event) {
                                return _vm.hide.apply(null, arguments)
                              },
                              mouseup: function($event) {
                                if ("button" in $event && $event.button !== 1) {
                                  return null
                                }
                                return _vm.hide.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.url))]
                        )
                      ])
                    ]
                  )
                ])
              : _c("div", { staticClass: "container-fluid" }, [
                  _c("p", [
                    _vm._v(
                      "Pour des raisons dépendantes du site du fournisseur, nous ne pouvons afficher directement la fiche technique."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous pouvez cliquer sur le lien suivant pour la télécharger :"
                    )
                  ]),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      },
                      on: {
                        click: function($event) {
                          return _vm.nouveauNavigateur(_vm.url)
                        },
                        contextmenu: function($event) {
                          return _vm.hide.apply(null, arguments)
                        },
                        mouseup: function($event) {
                          if ("button" in $event && $event.button !== 1) {
                            return null
                          }
                          return _vm.hide.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.url))]
                  ),
                  _c("p")
                ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }